// extracted by mini-css-extract-plugin
export default {"mySwiper":"Carousel_mySwiper__EaadN","swiperSlide":"Carousel_swiperSlide__wVvCK","img":"Carousel_img__lo3Hr"};